/**
 * @generated SignedSource<<52fa21e96d7935f07a88392741728075>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type decideTab_GroupQuery$variables = {
  counterparty: string;
};
export type decideTab_GroupQuery$data = {
  readonly sourcingReview: {
    readonly items: ReadonlyArray<{
      readonly amountCents: number;
      readonly candidates: ReadonlyArray<{
        readonly deltaCents: number;
        readonly exact: boolean;
        readonly payee: boolean;
        readonly rivalCounterparty: string | null | undefined;
        readonly rivalDate: string | null | undefined;
        readonly txn: {
          readonly amount: number;
          readonly description: string | null | undefined;
          readonly id: string;
          readonly postingDate: string | null | undefined;
        };
      }>;
      readonly entityType: string;
      readonly qboId: string;
      readonly txnDate: string | null | undefined;
      readonly verdict: string;
    }>;
  } | null | undefined;
};
export type decideTab_GroupQuery = {
  response: decideTab_GroupQuery$data;
  variables: decideTab_GroupQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "counterparty"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "counterparty",
    "variableName": "counterparty"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "qboId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityType",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "verdict",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amountCents",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "txnDate",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "SourcingBindCandidate",
  "kind": "LinkedField",
  "name": "candidates",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "QboBankTxn",
      "kind": "LinkedField",
      "name": "txn",
      "plural": false,
      "selections": [
        (v7/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "amount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "postingDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "exact",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "deltaCents",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "payee",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rivalCounterparty",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rivalDate",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "decideTab_GroupQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SourcingReview",
        "kind": "LinkedField",
        "name": "sourcingReview",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SourcingReviewItem",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "decideTab_GroupQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SourcingReview",
        "kind": "LinkedField",
        "name": "sourcingReview",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SourcingReviewItem",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v8/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "961ccb7c5fd40e8595daf3e018a0309f",
    "id": null,
    "metadata": {},
    "name": "decideTab_GroupQuery",
    "operationKind": "query",
    "text": "query decideTab_GroupQuery(\n  $counterparty: String!\n) {\n  sourcingReview(counterparty: $counterparty) {\n    items {\n      qboId\n      entityType\n      verdict\n      amountCents\n      txnDate\n      candidates {\n        txn {\n          id\n          amount\n          postingDate\n          description\n        }\n        exact\n        deltaCents\n        payee\n        rivalCounterparty\n        rivalDate\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "556e64f8c3f0b7b2a4ccb05e15ee1aa0";

export default node;
